<template>
  <div class="tickets-mail-detail-dialog">
    <el-dialog v-dialog-drag :visible.sync="showDialog" width="860px" :destroy-on-close="true" append-to-body
      :before-close="cancel" class="audit-dialog" title="发票邮寄详情">
      <div class="el-dialog-div">
        <!-- 发票信息 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-document"></i> 发票信息</span>
            <i :class="sectionOpen.invoiceInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              @click="toggleSection('invoiceInfo')" style="cursor: pointer; font-size: 14px; color: #909399;"></i>
          </div>
          <div class="tab-content" v-show="sectionOpen.invoiceInfo">
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">审核状态</span>
                <span class="detail-value">
                  <el-tag :type="getStatusColor(auditStatus,'tagType')"
                    :style="{color: getStatusColor(auditStatus,'color'),'background-color':getStatusColor(auditStatus,'backgroundColor')}">
                    {{getStatusColor(auditStatus,'name')}}</el-tag>
                </span>
              </div>
              <div class="detail-item" v-if="refundAuditStatus !== ''">
                <span class="detail-label">退票审核状态</span>
                <span class="detail-value">
                  <el-tag :type="getStatusColor(refundAuditStatus,'tagType')"
                    :style="{color: getStatusColor(refundAuditStatus,'color'),'background-color':getStatusColor(refundAuditStatus,'backgroundColor')}">
                    {{getStatusColor(refundAuditStatus,'name')}}</el-tag>
                </span>
              </div>
              <div class="detail-item" v-if="invoiceStatus !== ''">
                <span class="detail-label">发票状态</span>
                <span class="detail-value">
                  <el-tag :type="getInvoiceColor(invoiceStatus,'tagType')"
                    :style="{color: getInvoiceColor(invoiceStatus,'color'),'background-color':getInvoiceColor(invoiceStatus,'backgroundColor')}">
                    {{getInvoiceColor(invoiceStatus,'name')}}</el-tag>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建人</span>
                <span class="detail-value">{{ form.createBy }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建时间</span>
                <span class="detail-value">{{form.createTime}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">开票单位</span>
                <span class="detail-value">{{businessName}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票抬头</span>
                <span class="detail-value">{{invoiceTitle}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">负责人</span>
                <span class="detail-value">{{invoiceInfo['invoicingPrincipal'].name}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">销售</span>
                <span class="detail-value">{{invoiceInfo['sale'].name}}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">合同</span>
                <span class="detail-value">
                  <el-link v-for="(contractNumber,index) in invoiceInfo.contractNumbers" :key="'contract'+index"
                    type="primary" @click="openContractDialog(contractNumber)">{{ contractNumber + ' ,' }}</el-link>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">纳税登记编号</span>
                <span class="detail-value">{{taxRegistrationNumber}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">开户行&帐号</span>
                <span class="detail-value">{{bankAccountNumber}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票金额</span>
                <span class="detail-value"><span class="amount-text">{{form.invoiceAmount}}</span></span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票类型</span>
                <span class="detail-value">{{form.invoiceType}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票内容</span>
                <span class="detail-value">{{form.invoiceContent}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">备注</span>
                <span class="detail-value">{{form.remark}}</span>
              </div>
            </div>
            </div>
          </div>


        <!-- 发票信息导入 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-upload"></i> 发票信息导入</span>
          </div>
          <div>
            <div class="invoice-form">
              <el-form label-width="90px" ref="formA" :model="invoice" class="invoice-preview-form">
                <el-form-item label="发票抬头:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.invoiceTitle" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
                <el-form-item label="开票单位:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.businessName" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
                <el-form-item label="开票金额:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.invoiceAmount" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
                <el-form-item label="开票日期:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.invoiceDate" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
              </el-form>
              <el-form label-width="120px" ref="form" label-position="top" :model="form" :rules="rules" class="invoice-upload-form">
                <el-form-item label="发票信息导入：" prop="appendix" style="margin: 0 0 0 0">
                  <el-upload class="upload-demo" style="width: 100%" drag action="" accept=".pdf" :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" :file-list="fileList" :limit="1"
                    :on-exceed="handleExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">仅接受pdf文件，将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>

        <!-- 邮寄信息 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-truck"></i> 邮寄信息</span>
            <i :class="sectionOpen.mailInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              @click="toggleSection('mailInfo')" style="cursor: pointer; font-size: 14px; color: #909399;"></i>
          </div>
          <div class="tab-content" v-show="sectionOpen.mailInfo">
            <div class="detail-grid">
              <div class="detail-item full-width">
                <span class="detail-label">邮寄状态</span>
                <span class="detail-value">
                  <el-tag v-if="mail.mailFlag === 'NOT_APPLYING'" type="primary" color="white">未申请</el-tag>
                  <el-tag v-else-if="mail.mailFlag === 'SUBMITTED' && mail.mailAuditFlag" type="warning"
                    style="background-color: #FFFFFF">待邮寄</el-tag>
                  <el-tag v-else-if="mail.mailFlag === 'SUBMITTED' && !mail.mailAuditFlag" type="warning">待审核</el-tag>
                  <el-tag v-else-if="mail.mailFlag === 'MAILED'" type="success">已邮寄</el-tag>
                  <el-tag v-else-if="mail.mailFlag === 'CANCELED'" type="warning">已取消</el-tag>
                  <el-tag v-else type="info">未知状态</el-tag>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建人</span>
                <span class="detail-value">{{ mail.createBy }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建时间</span>
                <span class="detail-value">{{mail.createTime}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">销售</span>
                <span class="detail-value">{{mail.applicantName}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">申请时间</span>
                <span class="detail-value">{{mail.applicantDate}}</span>
              </div>
              <div class="detail-item" v-if="mail.principalName!==''">
                <span class="detail-label">负责人</span>
                <span class="detail-value">{{mail.principalName}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">收件人</span>
                <span class="detail-value">{{mail.recipientName}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">收件人电话</span>
                <span class="detail-value">{{mail.recipientPhone}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">收件地址</span>
                <span class="detail-value">{{mail.recipientAddress}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">备注</span>
                <span class="detail-value">{{mail.remark}}</span>
              </div>
            </div>
            </div>
          </div>


        <!-- 已上传寄件单号 -->
        <div class="section-card" v-if="Object.keys(mail.mailNumbers).length>0">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-tickets"></i> 已上传寄件单号</span>
            <i :class="sectionOpen.mailNumbers ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              @click="toggleSection('mailNumbers')" style="cursor: pointer; font-size: 14px; color: #909399;"></i>
          </div>
          <div class="tab-content" v-show="sectionOpen.mailNumbers">
            <div class="mail-number-list">
              <div class="mail-number-item" v-for="(mailNumber,index) in Object.keys(mail.mailNumbers)" :key="index">
                <div class="detail-grid">
                  <div class="detail-item">
                    <span class="detail-label">寄件单号</span>
                    <span class="detail-value"><span class="tracking-number">{{ mailNumber }}</span></span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">上传时间</span>
                    <span class="detail-value">{{ mail.mailNumbers[mailNumber] }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 邮寄内容 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-box"></i> 邮寄内容</span>
          </div>
          <div class="tab-content">
            <mailing-content :select-detail="selectDetail['mailInfoDTO']"></mailing-content>
          </div>
        </div>

        <!-- 快递单号录入 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-edit"></i> 快递单号录入</span>
          </div>
          <div class="tab-content">
            <el-form label-width="120px" ref="formMail" :model="formMail">
              <div v-for="(mailNumber, index) in formMail.numbers" :key="index" class="mail-number-input-item">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="快递单号" :prop="'numbers.'+index+'.label'"
                      :rules="{required: true, message: '请输入快递单号', trigger: 'change'}">
                      <el-input style="width: 360px;" v-model="mailNumber.label" placeholder="请输入快递单号"
                        auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item>
                      <el-button type="danger" size="mini" icon="el-icon-delete"
                        @click="handleDelete(mailNumber)">删除</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="快递单号" prop="mailNumber.label"
                    :rules="{required: true, message: '请扫描快递单号或者输入快递单号', trigger: 'change'}">
                    <scan-the-code style="width: 360px;" ref="courierNoInput" v-model="formMail.mailNumber.label"
                      placeholder="请扫描快递单号或者输入快递单号" :hasCleared="hasCleared"></scan-the-code>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-button size="small" type="danger" icon="el-icon-delete" class="title"
                      @click="handleDelete()">删除</el-button>
                    <el-button size="small" v-if="formMail.mailNumber.label" type="success" class="title"
                      @click="handleAdd">新增快递单号</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="邮寄情况" prop="mailFlag">
                <el-select style="width: 360px;" v-model="formMail.mailFlag" placeholder="请选择邮寄完成情况" filterable>
                  <el-option v-for="item in FlagOptions" :key="item.label" :label="item.name"
                    :value="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class="title" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
    <contract-details v-if="showContractDetails" :show-dialog="showContractDetails" :select-detail="[ContractDetail]"
      @submit="close1"></contract-details>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>
import {editTickets, getPdfNum} from "@/api/dilivery/tickets";
import ScanTheCode from "@/components/scanTheCode.vue";
import FilePreview from "@/components/file/FilePreview.vue";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import {getContractPage} from "@/api/dilivery/sales/contract";
import {viewDetailIcon} from "@/utils/icon";
import ExFoldTable from "@/components/ExFoldTable.vue";
import MailingContent from "@/components/mail/MailingContent.vue";
import {getInvoiceColor, getStatusColor} from "@/color";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "TicketsMailDetail",
  components: { MailingContent, ExFoldTable, ContractDetails, FilePreview, ScanTheCode, Loading },
  props:['showDialog','selectDetail'],
  data(){
    return {
      loading:false,
      showContractDetails: false,
      sectionOpen: {
        invoiceInfo: true,
        mailInfo: true,
        mailNumbers: true,
      },
      ContractDetail: '',
      fileList: [], // 附件上传文件列表
      auditStatus:'',
      refundAuditStatus:'',
      invoiceStatus:'',
      bankAccountNumber:'',
      taxRegistrationNumber:'',
      invoiceTitle: '',
      businessName: '',
      invoiceInfo:{},
      hasCleared:false,
      mail: {},
      FlagOptions: [
        {label:false,name:'完成部分邮寄，快递单号未添加完成'},
        {label:true,name:'已完成全部邮寄，快递单号添加完成'}
      ],
      formMail:{
        id:'',
        mailNumber: {label:''},
        mailNumbers:[],
        numbers: [],
        mailFlag:true,
      },
      invoice: {
        invoiceDate:'',
        invoiceNumber:'',
        invoiceTitle: '',
        invoiceAmount: '',
        businessName: ''
      },
      form: {
        invoiceDate:'',
        appendixExist:true,
        appendix:null,
        invoiceNumber: '',
        invoiceAmount: 0,
        invoiceType: '普票',
        remark: ''
      },
      viewDetailIcon: viewDetailIcon,
      rules: {
        invoiceNumber:[
          {required: true,message: '请输入发票号码', trigger: 'change'}
        ],
        appendix: [
          {required: true, message: '请上传附件', trigger: 'change'}
        ],
      },
    }
  },
  watch: {
    'form.appendix' : {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.getNum()
        }
      },
      immediate: true
    },
    'selectDetail': {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id
          this.auditStatus = newVal.auditStatus
          if(newVal.refundAuditStatus !== null){
            this.refundAuditStatus = newVal.refundAuditStatus
          }
          if(newVal.invoiceStatus !== null){
            this.invoiceStatus = newVal.invoiceStatus
          }
          this.invoiceInfo = {...newVal}
          this.invoiceTitle = newVal.invoiceTitle
          this.taxRegistrationNumber = newVal.taxRegistrationNumber
          this.bankAccountNumber = newVal.bankAccountNumber
          this.businessName = newVal['billingUnit'].companyName
          this.form.createBy = newVal.createBy
          this.form.invoiceRecordId = newVal.invoiceRecordId
          this.form.createTime = newVal.createTime
          this.form.invoiceAmount = newVal.invoiceAmount
          this.form.invoiceNumber = newVal.invoiceNumber
          this.form.invoiceType = newVal.invoiceType
          this.form.invoiceContent = newVal.invoiceContent
          this.form.remark = newVal.remark


          this.formMail.id = newVal['mailInfoDTO'].id
          this.mail.mailNumbers = newVal['mailInfoDTO'].mailNumbers
          this.mail.id = newVal['mailInfoDTO'].id
          this.mail.remark = newVal['mailInfoDTO'].remark
          this.mail.rejectionReason = newVal['mailInfoDTO'].rejectionReason
          this.mail.status = newVal['mailInfoDTO'].status
          this.mail.createBy = newVal['mailInfoDTO'].createBy
          this.mail.createTime = newVal['mailInfoDTO'].createTime
          this.mail.applicantDate = newVal['mailInfoDTO'].applicantDate
          this.mail.mailingContent = newVal['mailInfoDTO'].mailingContent
          this.mail.mailFlag = newVal['mailInfoDTO'].mailFlag
          if(newVal['mailInfoDTO']['mailPrincipal']){
            this.mail.principalName = newVal['mailInfoDTO']['mailPrincipal'].name
          }
          if(newVal['mailInfoDTO'].operatingPersonName!==null){
            this.mail.operatingPersonName = newVal['mailInfoDTO'].operatingPersonName
          }
          if(newVal['mailInfoDTO'].operatingTime!==null){
            this.mail.operatingTime = newVal['mailInfoDTO'].operatingTime
          }
          if(newVal['mailInfoDTO']['applicant']!==null){
            this.mail.applicantName = newVal['mailInfoDTO']['applicant'].name
          }
          this.mail.recipientPhone = newVal['mailInfoDTO'].recipientPhone
          this.mail.recipientAddress = newVal['mailInfoDTO'].recipientAddress
          this.mail.recipientName = newVal['mailInfoDTO'].recipientName
          this.mail.mailAttachment = newVal['mailInfoDTO'].mailAttachment
        }
      },
      immediate: true
    },
  },
  methods: {
    toggleSection(key) {
      this.sectionOpen[key] = !this.sectionOpen[key];
    },
    getStatusColor,
    getInvoiceColor,
    getNum(){
        let param = {
          'id' : this.form.id
        }
        const formData = new FormData();
        if (this.form.appendix) {
          formData.append('file', this.form.appendix.raw); // 文件
        } else {
          const emptyFile = new File([], '')
          formData.append('file', emptyFile);
        }
        getPdfNum(param,formData).then(res=>{
          if(res.code === 200){
            this.form.invoiceNumber = res.data.invoiceNumber
            this.invoice.invoiceNumber = res.data.invoiceNumber
            this.invoice.invoiceAmount = res.data['invoicePrice']
            this.invoice.invoiceDate = res.data['invoiceDate']
            const name = res.data['name'].split(',')
            this.invoice.invoiceTitle = name[0].trim()
            this.invoice.businessName = name[1].trim()
          }
        }).catch(err => {
          this.form.invoiceNumber = ''
          this.invoice.invoiceAmount = ''
          this.invoice.invoiceDate = ''
          this.invoice.invoiceTitle = ''
          this.invoice.businessName = ''
        })
    },
    formatAmount(amount) {
      const parsedAmount = parseFloat(amount);
      return parsedAmount.toFixed(2);
    },
    removeSpaces(str) {
      // 使用 trim 方法去掉字符串的前后空格
      return str.replace(/[^\u4e00-\u9fa5]/g, '');
    },
    compareInvoice() {
      const isCompany = this.removeSpaces(this.invoice.invoiceTitle) !== this.removeSpaces(this.invoiceTitle);
      const isAmount = this.formatAmount(this.invoice.invoiceAmount) !== this.formatAmount(this.form.invoiceAmount);
      const isBusiness = this.removeSpaces(this.invoice.businessName) !== this.removeSpaces(this.businessName);
      return isCompany || isAmount || isBusiness;
    },
    handleDelete(item) {
      if(item){
        const index = this.formMail.numbers.indexOf(item)
        if (index !== -1) {
          this.formMail.numbers.splice(index, 1)
        }
      }else{
        let lastElement = this.formMail.numbers.pop();
        if(lastElement){
          this.formMail.mailNumber = lastElement
        }else{
          this.formMail.mailNumber = {label: ''}
        }
      }
    },
    close1(){
      this.showContractDetails = false
    },
    openContractDialog(contractNumber){
      let param = {}
      let data = {
        "query#contractNumber.EQ":contractNumber
      }
      getContractPage(param,data).then(res=>{
        if(res.code === 200){
          if(res.data.records.length === 0){
            this.$messageUi.error("打开合同详情失败")
          }else{
            this.ContractDetail = res.data.records[0]
            this.showContractDetails = true
          }
        }
      }).catch(error=>{
      })
    },
    handleAdd() {
      if(this.formMail.mailNumber.label){
        const mailNumber = {label:this.formMail.mailNumber.label}
        this.formMail.numbers.push(mailNumber)
        this.formMail.mailNumber.label = ''
      }else{
        this.$messageUi.error('')
      }
    },
    handleChange(file, fileList) {
      // 当文件选择发生变化时触发此方法
      this.form.appendix = file; // 更新已选择的文件
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      // 可选，处理文件移除逻辑
      this.form.appendix = null; // 更新已选择的文件
      this.fileList = fileList
    },
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传'); // 超出数量时提醒
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    validateForm(ref) {
      return new Promise((resolve) => {
        this.$refs[ref].validate((valid) => {
          resolve(valid);
        });
      });
    },
    async handle(){
      try{
        const [ticketsFormValid, mailFormValid] = await Promise.all([
          this.validateForm('form'),
          this.validateForm('formMail')
        ]);
        if (ticketsFormValid && mailFormValid) {
          if (this.compareInvoice()) {
            this.$messageUi.error('导入发票信息与目标发票信息不一致，请检查')
            return
          }
          if (!this.invoice.invoiceDate) {
            this.$messageUi.error('开票日期不存在，请检查')
            return
          }
          this.loading = true
          const formData = new FormData();
          if (this.form.appendix) {
            formData.append('file', this.form.appendix.raw); // 文件
          } else {
            const emptyFile = new File([], '')
            formData.append('file', emptyFile);
          }
          this.form.invoiceDate = this.invoice.invoiceDate
          const jsonStr = JSON.stringify(
            Object.keys(this.form).reduce((acc, key) => {
              if (key !== 'appendix') {
                acc[key] = this.form[key];
              }
              return acc;
            }, {})
          );
          const blob = new Blob([jsonStr], {
            type: 'application/json'
          });
          formData.append("info", blob);
          this.formMail.mailNumbers = this.formMail.numbers.map(item => item.label)
          this.formMail.mailNumbers.push(this.formMail.mailNumber.label)
          const jsonStr2 = JSON.stringify(this.formMail);
          const blob2 = new Blob([jsonStr2], {
            type: 'application/json'
          });
          formData.append("mailNumberInfo", blob2);
          const response = await editTickets(formData)
          this.loading = false
          if (response.code === 200) {
            this.$messageUi.success('发票号码添加成功')
            this.$emit('submit', 'confirm')
            this.$store.commit('right/setChangeRed', true)
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      }catch(error) {
        console.log(error);
        this.loading = false
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.tickets-mail-detail-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
       .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";
.el-dialog-div {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 5px;
  
  @include thin-scrollbar(8px, #888);
}

.invoice-form {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}

.invoice-preview-form {
  width: 45%;
}

.invoice-upload-form {
  width: 55%;
}

.upload-demo {
  margin-top: 10px;
}

.mail-number-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mail-number-item {
  padding: 10px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.mail-number-input-item {
  margin-bottom: 10px;
  padding: 10px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.tracking-number {
  font-weight: 500;
  color: #409eff;
}

</style>
